import "../../common/polyfills";
import * as React from "react";
import * as ReactDOM from "react-dom";
import {WebFoxCarousel, ICarouselProps} from "./Carousel"

function MountCarousel(props: ICarouselProps, el: Element) {
    ReactDOM.render(<WebFoxCarousel {...props} />, el)
}

(window as any).MountCarousel = MountCarousel;